<div class="news-info-container">
  <div class="title">Mensagem</div>
  <div class="description-text">
    <span
      [innerHTML]="news?.description | transformLink | sanitizeHtml"
      style="white-space: pre-line"
    >
    </span>
  </div>
  <div class="title">
    {{ attachmentText }}
  </div>
  <div class="attachments">
    <div *ngFor="let fileData of downloadFilesControl; index as i">
      <div class="file-item">
        <app-file-uploaded-item
          [filePathOldStructure]="attachmentsPath"
          [fileData]="fileData"
          [allowDelete]="false"
          [imgURL]="null"
        >
        </app-file-uploaded-item>
      </div>
    </div>
  </div>
</div>
